import { useMediaQuery } from 'usehooks-ts'

import DesktopModal from './DesktopModal'
import MobileModal from './MobileModal'

import { ModalComponentProps } from '@/typings/Modals'
import { asUseMediaQuery } from '@/utils/mediaQuery'

export default function DefaultModal({
  confirmButtonText = 'OK',
  cancelButtonText = 'Cancel',

  ...props
}: ModalComponentProps) {
  const isMobile = useMediaQuery(asUseMediaQuery('sm'))

  if (isMobile)
    return (
      <MobileModal
        {...props}
        confirmButtonText={confirmButtonText}
        cancelButtonText={cancelButtonText}
      />
    )

  return (
    <DesktopModal
      {...props}
      confirmButtonText={confirmButtonText}
      cancelButtonText={cancelButtonText}
    />
  )
}
